<!-- 饭制皮套组件 -->
<template>
    <div class="fanmade-live2d">
        <el-card class="section-title-card">
            <div class="section-main-title">饭制皮套</div>
            <div class="section-description">
                由于我社恐且不善社交，所以有部分宝宝未能收集到人设图并登记🙏特此滑跪，如果后续收集到将会立刻更新上去！
            </div>
        </el-card>

        <!-- 浮动导航栏组件 -->
        <nav-menu :models="models" :show-back-to-top="showBackToTop" :key="'fanmade'"></nav-menu>
        <!-- 模型卡片列表 -->
        <model-card v-for="model in models" :key="model.id" :model="model"></model-card>

    </div>
</template>

<script>
import ModelCard from './ModelCard.vue';
import NavMenu from './NavMenu.vue';

export default {
    name: 'FanmadeLive2d',
    components: {
        ModelCard,
        NavMenu
    },
    data() {
        return {
            // 控制回到顶部按钮显示
            showBackToTop: false,
            // 模型列表数据
            models: [
                {
                    id: 'cat',
                    name: '雪小猫',
                    carouselItems: [
                        {
                            image: require('@/assets/雪小猫.jpg'),
                            title: '雪小猫'
                        }
                    ],
                    downloadText: '下载立绘',
                    infoItems: [
                        { label: '类型', value: '饭制皮套' },
                        { label: '昵称', value: '河南猫' },
                        { label: '粉丝名', value: '猫条儿' },
                        { label: '赠送人', value: '明天就重生' },
                        { label: '初次亮相', value: '2025年3月14日' }
                    ]
                },
                {
                    id: 'nini',
                    name: '雪妮妮',
                    carouselItems: [
                        {
                            image: require('@/assets/雪妮妮-01.jpg'),
                            title: '雪妮妮-01'
                        },
                        {
                            image: require('@/assets/雪妮妮-02.jpg'),
                            title: '雪妮妮-02'
                        },
                        {
                            image: require('@/assets/雪妮妮-03.jpg'),
                            title: '雪妮妮-03'
                        }
                    ],
                    downloadText: '下载图片',
                    infoItems: [
                        { label: '类型', value: '饭制皮套' },
                        { label: '昵称', value: '妮妮、妮妮公主、雪国大公主' },
                        { label: '粉丝名', value: '芭比粉' },
                        { label: '赠送人', value: '柾不想上班' },
                        { label: '初次亮相', value: '2025年4月7日' },
                        { label: '其他', value: '2025年12月31日，3D皮套释出' },
                        { label: '  ', value: '2026年2月10日，过年新装释出' },
                    ]
                },
                {
                    id: 'wanger',
                    name: '雪旺旺',
                    carouselItems: [
                        {
                            image: require('@/assets/雪旺旺-01.jpg'),
                            title: '雪旺旺-01'
                        },
                        {
                            image: require('@/assets/雪旺旺-02.jpg'),
                            title: '雪旺旺-02'
                        },
                        {
                            image: require('@/assets/大旺旺-01.png'),
                            title: '大旺旺-01'
                        },
                        {
                            image: require('@/assets/大旺旺-02.png'),
                            title: '大旺旺-02'
                        },
                        {
                            image: require('@/assets/大旺旺-03.png'),
                            title: '大旺旺-03'
                        },

                    ],
                    downloadText: '下载图片',
                    infoItems: [
                        { label: '类型', value: '饭制皮套' },
                        { label: '昵称', value: '旺旺、旺旺大旺' },
                        { label: '粉丝名', value: '旺仔' },
                        { label: '赠送人', value: '①贰ⅲ4❺6柒' },
                        { label: '初次亮相', value: '2025年4月17日' },
                        { label: '其他', value: '成年版雪旺旺于2025年9月4日亮相' }
                    ]
                },
                // {
                //     id: 'guoguo',
                //     name: '雪果果',
                //     carouselItems: [
                //         {
                //             image: require('@/assets/雪果果.jpg'),
                //             title: '雪果果-01'
                //         }
                //     ],
                //     downloadText: '下载图片',
                //     infoItems: [
                //         { label: '类型', value: '饭制皮套' },
                //         { label: '昵称', value: '果果' },
                //         { label: '赠送人', value: '言妍' },
                //         { label: '初次亮相', value: '2025年4月28日' }
                //     ]
                // },
                // {
                //     id: 'ruirui',
                //     name: '雪瑞瑞',
                //     carouselItems: [
                //         {
                //             image: require('@/assets/雪瑞瑞-01.jpg'),
                //             title: '雪瑞瑞-01'
                //         },
                //         {
                //             image: require('@/assets/雪瑞瑞-02.jpg'),
                //             title: '雪瑞瑞-02'
                //         }
                //     ],
                //     downloadText: '下载图片',
                //     infoItems: [
                //         { label: '类型', value: '饭制皮套' },
                //         { label: '昵称', value: '瑞瑞' },
                //         { label: '赠送人', value: '崩溃的牛郎' },
                //         { label: '初次亮相', value: '2025年4月29日' }
                //     ]
                // },
                {
                    id: 'rongrong',
                    name: '雪榕榕',
                    carouselItems: [
                        {
                            image: require('@/assets/雪榕榕-01.jpg'),
                            title: '雪榕榕-01'
                        },
                        {
                            image: require('@/assets/雪榕榕-02.jpg'),
                            title: '雪榕榕-02'
                        },
                        {
                            image: require('@/assets/榕榕睡衣1.jpg'),
                            title: '榕榕睡衣1'
                        },
                        {
                            image: require('@/assets/榕榕睡衣2.jpg'),
                            title: '榕榕睡衣2'
                        },
                        {
                            image: require('@/assets/榕榕睡衣3.jpg'),
                            title: '榕榕睡衣3'
                        },
                        {
                            image: require('@/assets/榕榕睡衣4.jpg'),
                            title: '榕榕睡衣4'
                        },
                        {
                            image: require('@/assets/榕榕睡衣5.jpg'),
                            title: '榕榕睡衣5'
                        },
                        {
                            image: require('@/assets/榕榕睡衣6.jpg'),
                            title: '榕榕睡衣6'
                        },
                        {
                            image: require('@/assets/榕榕睡衣7.jpg'),
                            title: '榕榕睡衣7'
                        }
                    ],
                    downloadText: '下载图片',
                    infoItems: [
                        { label: '类型', value: '饭制皮套' },
                        { label: '昵称', value: '榕榕、恶霸兔、邪恶兔子' },
                        { label: '赠送人', value: '杨' },
                        { label: '初次亮相', value: '2025年6月9日' },
                        { label: '其他', value: '2025年8月22日，睡衣套释出' },
                        { label: '  ', value: '2025年12月24日，榕皇套释出' },
                        { label: '  ', value: '2026年6月9日，雪榕榕3D套释出' },
                    ]
                },
                {
                    id: 'yaoer',
                    name: '雪幺儿',
                    carouselItems: [
                        {
                            image: require('@/assets/雪幺儿-01.jpg'),
                            title: '雪幺儿-01'
                        },
                        {
                            image: require('@/assets/雪幺儿-02.jpg'),
                            title: '雪幺儿-02'
                        }
                    ],
                    downloadText: '下载图片',
                    infoItems: [
                        { label: '类型', value: '饭制皮套' },
                        { label: '昵称', value: '幺儿' },
                        { label: '赠送人', value: '左眼皮有颗痣•́‸ก' },
                        { label: '初次亮相', value: '2025年6月9日' }
                    ]
                },
                {
                    id: 'langlang',
                    name: '雪琅琅',
                    carouselItems: [
                        {
                            image: require('@/assets/雪琅琅.jpg'),
                            title: '雪琅琅'
                        }
                    ],
                    downloadText: '下载图片',
                    infoItems: [
                        { label: '类型', value: '饭制皮套' },
                        { label: '昵称', value: '琅琅' },
                        { label: '赠送人', value: '璃月' },
                        { label: '初次亮相', value: '2025年6月25日' }
                    ]
                },
                {
                    id: 'tongtong',
                    name: '雪桐桐',
                    carouselItems: [
                        {
                            image: require('@/assets/雪桐桐-01.jpg'),
                            title: '雪桐桐-01'
                        },
                        {
                            image: require('@/assets/雪桐桐-02.jpg'),
                            title: '雪桐桐-02'
                        },
                        {
                            image: require('@/assets/雪桐桐-03.jpg'),
                            title: '雪桐桐-03'
                        },
                    ],
                    downloadText: '下载图片',
                    infoItems: [
                        { label: '类型', value: '饭制皮套' },
                        { label: '昵称', value: '桐桐' },
                        { label: '赠送人', value: '木槿木槿灵麻麻酱' },
                        { label: '初次亮相', value: '2025年7月1日' }
                    ]
                },
                {
                    id: 'doudou',
                    name: '雪豆豆',
                    carouselItems: [
                        {
                            image: require('@/assets/雪豆豆-01.png'),
                            title: '雪豆豆-01'
                        },
                        {
                            image: require('@/assets/雪豆豆-02.png'),
                            title: '雪豆豆-02'
                        },
                        {
                            image: require('@/assets/雪豆豆-03.png'),
                            title: '雪豆豆-03'
                        },
                    ],
                    downloadText: '下载图片',
                    infoItems: [
                        { label: '类型', value: '饭制皮套' },
                        { label: '昵称', value: '豆豆' },
                        { label: '粉丝名', value: '豆粉' },
                        { label: '赠送人', value: '比巴卜xinxin' },
                        { label: '初次亮相', value: '2025年7月2日' }
                    ]
                },
                {
                    id: 'youyou',
                    name: '雪呦呦',
                    carouselItems: [
                        {
                            image: require('@/assets/雪呦呦-01.png'),
                            title: '雪呦呦-01'
                        },
                        {
                            image: require('@/assets/雪呦呦-02.png'),
                            title: '雪呦呦-02'
                        },
                        {
                            image: require('@/assets/雪呦呦-03.png'),
                            title: '雪呦呦-03'
                        },
                        {
                            image: require('@/assets/雪呦呦-04.png'),
                            title: '雪呦呦-04'
                        },
                        {
                            image: require('@/assets/雪呦呦-05.png'),
                            title: '雪呦呦-05'
                        },
                    ],
                    downloadText: '下载图片',
                    infoItems: [
                        { label: '类型', value: '饭制皮套' },
                        { label: '昵称', value: '呦呦' },
                        { label: '赠送人', value: '奶酥菠萝包' },
                        { label: '初次亮相', value: '2025年7月21日' }
                    ]
                },
                {
                    id: 'lili',
                    name: '雪璃璃',
                    carouselItems: [
                        {
                            image: require('@/assets/雪璃璃-01.jpg'),
                            title: '雪璃璃-01'
                        },
                        {
                            image: require('@/assets/雪璃璃-02.jpg'),
                            title: '雪璃璃-02'
                        },
                        {
                            image: require('@/assets/雪璃璃-03.jpg'),
                            title: '雪璃璃-03'
                        },

                    ],
                    downloadText: '下载图片',
                    infoItems: [
                        { label: '类型', value: '饭制皮套' },
                        { label: '昵称', value: '璃璃' },
                        { label: '赠送人', value: '比巴卜xinxin' },
                        { label: '初次亮相', value: '2025年7月30日' }
                    ]
                },
                {
                    id: 'xiaoxiao',
                    name: '雪枭枭',
                    carouselItems: [
                        {
                            image: require('@/assets/雪枭枭.jpg'),
                            title: '雪枭枭'
                        },
                    ],
                    downloadText: '下载图片',
                    infoItems: [
                        { label: '类型', value: '饭制皮套' },
                        { label: '昵称', value: '枭枭' },
                        { label: '赠送人', value: '杨' },
                        { label: '初次亮相', value: '2025年8月3日' },
                        { label: '其他', value: '枭枭为黑白双相' }
                    ]
                },
                {
                    id: 'jiangjiang',
                    name: '雪酱酱',
                    carouselItems: [
                        {
                            image: require('@/assets/雪酱酱-辣酱.jpg'),
                            title: '雪酱酱-辣酱'
                        },
                        {
                            image: require('@/assets/雪酱酱-甜酱.jpg'),
                            title: '雪酱酱-甜酱'
                        },
                    ],
                    downloadText: '下载图片',
                    infoItems: [
                        { label: '类型', value: '饭制皮套' },
                        { label: '昵称', value: '酱酱、甜酱、辣酱、甜辣酱' },
                        { label: '赠送人', value: '柾不想上班' },
                        { label: '初次亮相', value: '2025年8月10日' },
                        { label: '其他', value: '甜酱辣酱一体双生' }
                    ]
                },
                {
                    id: 'nuonuo',
                    name: '雪糯糯',
                    carouselItems: [
                        {
                            image: require('@/assets/雪糯糯-01.png'),
                            title: '雪糯糯-01'
                        },
                        {
                            image: require('@/assets/雪糯糯-02.png'),
                            title: '雪糯糯-02'
                        },
                        {
                            image: require('@/assets/雪糯糯-03.png'),
                            title: '雪糯糯-03'
                        },
                        {
                            image: require('@/assets/雪糯糯-04.png'),
                            title: '雪糯糯-04'
                        },
                        {
                            image: require('@/assets/雪糯糯-05.png'),
                            title: '雪糯糯-05'
                        },
                    ],
                    downloadText: '下载图片',
                    infoItems: [
                        { label: '类型', value: '饭制皮套' },
                        { label: '昵称', value: '糯糯' },
                        { label: '赠送人', value: 'S1eeepy' },
                        { label: '初次亮相', value: '2025年8月13日' },
                    ]
                },
                {
                    id: 'xixi',
                    name: '雪晞晞',
                    carouselItems: [
                        {
                            image: require('@/assets/雪晞晞-01.jpg'),
                            title: '雪晞晞-01'
                        },
                        {
                            image: require('@/assets/雪晞晞-02.jpg'),
                            title: '雪晞晞-02'
                        },

                    ],
                    downloadText: '下载图片',
                    infoItems: [
                        { label: '类型', value: '饭制皮套' },
                        { label: '昵称', value: '晞晞、生鱼片、飞鱼' },
                        { label: '赠送人', value: '二木' },
                        { label: '初次亮相', value: '2025年9月11日' },
                    ]
                },
                {
                    id: 'xiaoxueren',
                    name: '小雪人',
                    carouselItems: [
                        {
                            image: require('@/assets/小雪人-01.jpg'),
                            title: '小雪人-01'
                        },
                        {
                            image: require('@/assets/小雪人-02.jpg'),
                            title: '小雪人-02'
                        },
                        {
                            image: require('@/assets/小雪人-03.jpg'),
                            title: '小雪人-03'
                        },
                        {
                            image: require('@/assets/小雪人-04.jpg'),
                            title: '小雪人-04'
                        },
                        {
                            image: require('@/assets/小雪人-05.jpg'),
                            title: '小雪人-05'
                        },
                        {
                            image: require('@/assets/小雪人-06.jpg'),
                            title: '小雪人-06'
                        },
                    ],
                    downloadText: '下载图片',
                    infoItems: [
                        { label: '类型', value: '饭制皮套' },
                        { label: '昵称', value: '小雪人' },
                        { label: '赠送人', value: '听听' },
                        { label: '初次亮相', value: '2025年9月22日' },
                        { label: '其他', value: '本作品从严格意义上算不上皮套，放在这是出于我的一点私心。' },
                    ]
                },
                {
                    id: 'tuantuan',
                    name: '雪团团',
                    carouselItems: [
                        {
                            image: require('@/assets/雪团团-01.jpg'),
                            title: '雪团团-01'
                        },
                        {
                            image: require('@/assets/雪团团-02.jpg'),
                            title: '雪团团-02'
                        },
                        {
                            image: require('@/assets/雪团团-03.jpg'),
                            title: '雪团团-03'
                        },
                    ],
                    downloadText: '下载图片',
                    infoItems: [
                        { label: '类型', value: '饭制皮套' },
                        { label: '昵称', value: '团团' },
                        { label: '赠送人', value: '喵喵喵下muamua雨' },
                        { label: '初次亮相', value: '2025年9月23日' },
                    ]
                },
                {
                    id: 'chacha',
                    name: '雪茶茶',
                    carouselItems: [
                        {
                            image: require('@/assets/雪茶茶-01.jpg'),
                            title: '雪茶茶-01'
                        },
                        {
                            image: require('@/assets/雪茶茶-02.jpg'),
                            title: '雪茶茶-02'
                        },
                        {
                            image: require('@/assets/雪茶茶-03.jpg'),
                            title: '雪茶茶-03'
                        },
                        {
                            image: require('@/assets/雪茶茶-04.png'),
                            title: '雪茶茶-04'
                        },
                        {
                            image: require('@/assets/雪茶茶-05.png'),
                            title: '雪茶茶-05'
                        },
                    ],
                    downloadText: '下载图片',
                    infoItems: [
                        { label: '类型', value: '饭制皮套' },
                        { label: '昵称', value: '茶茶' },
                        { label: '赠送', value: 'CJCH' },
                        { label: '初次亮相', value: '2025年9月23日' },
                    ]
                },
                {
                    id: 'zhaozhao',
                    name: '雪昭昭',
                    carouselItems: [
                        {
                            image: require('@/assets/雪昭昭-01.jpg'),
                            title: '雪昭昭-01'
                        },
                        {
                            image: require('@/assets/雪昭昭-02.jpg'),
                            title: '雪昭昭-02'
                        },
                        {
                            image: require('@/assets/雪昭昭-03.jpg'),
                            title: '雪昭昭-03'
                        },
                    ],
                    downloadText: '下载图片',
                    infoItems: [
                        { label: '类型', value: '饭制皮套' },
                        { label: '昵称', value: '昭昭' },
                        { label: '赠送人', value: '今天又想吃蛋挞了' },
                        { label: '初次亮相', value: '2025年9月30日' },
                    ]
                },
                {
                    id: 'qian',
                    name: '雪祁安',
                    carouselItems: [
                        {
                            image: require('@/assets/雪祁安.jpg'),
                            title: '雪祁安'
                        },
                    ],
                    downloadText: '下载图片',
                    infoItems: [
                        { label: '类型', value: '饭制皮套' },
                        { label: '昵称', value: '祁安' },
                        { label: '赠送人', value: '瞳瞳瞳' },
                        { label: '初次亮相', value: '2025年12月25日' },
                    ]
                },
                {
                    id: 'zhenzhu',
                    name: '雪珍珠',
                    carouselItems: [
                        {
                            image: require('@/assets/雪珍珠-01.png'),
                            title: '雪珍珠-01'
                        },
                        {
                            image: require('@/assets/雪珍珠-02.png'),
                            title: '雪珍珠-02'
                        },
                        {
                            image: require('@/assets/雪珍珠-03.png'),
                            title: '雪珍珠-03'
                        },
                        {
                            image: require('@/assets/雪珍珠-04.png'),
                            title: '雪珍珠-04'
                        },
                    ],
                    downloadText: '下载图片',
                    infoItems: [
                        { label: '类型', value: '饭制皮套' },
                        { label: '昵称', value: '珍珠' },
                        { label: '赠送人', value: '雪宝只做小公主' },
                        { label: '初次亮相', value: '2026年6月2日' },
                    ]
                },
                {
                    id: 'zhizhi',
                    name: '雪枝枝',
                    carouselItems: [
                        {
                            image: require('@/assets/雪枝枝-01.jpg'),
                            title: '雪枝枝-01'
                        },
                        {
                            image: require('@/assets/雪枝枝-02.png'),
                            title: '雪枝枝-02'
                        },
                    ],
                    downloadText: '下载图片',
                    infoItems: [
                        { label: '类型', value: '饭制皮套' },
                        { label: '昵称', value: '枝枝' },
                        { label: '赠送人', value: '落羽' },
                        { label: '初次亮相', value: '2026年6月9日' },
                    ]
                },
            ]
        };
    },
    methods: {
        // 回到顶部功能
        scrollToTop() {
            // 查找实际的滚动容器（main-content）
            const scrollContainer = document.querySelector('.main-content');

            if (scrollContainer) {
                // 优先滚动到main-content容器的顶部
                scrollContainer.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            } else {
                // 如果找不到main-content容器，则回退到滚动整个窗口
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        },
        async downloadImage(imageSrc, filename) {
            try {
                // 获取图片URL
                let imageUrl = imageSrc;

                // 处理webpack资源ID
                if (typeof imageSrc === 'number') {
                    // 创建临时图片获取完整路径
                    const img = new Image();
                    img.src = imageSrc;
                    imageUrl = img.src;
                }

                // 创建canvas处理图片
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                const img = new Image();

                // 设置跨域
                img.crossOrigin = 'Anonymous';

                // 等待图片加载
                await new Promise((resolve, reject) => {
                    img.onload = resolve;
                    img.onerror = () => reject(new Error('图片加载失败'));
                    img.src = imageUrl;

                    // 处理缓存中的图片
                    if (img.complete) {
                        resolve();
                    }
                });

                // 设置canvas尺寸
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0);

                // 转换为blob并下载
                canvas.toBlob((blob) => {
                    if (blob) {
                        const url = URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.download = `${filename}.jpg`;
                        document.body.appendChild(link);
                        link.click();

                        // 清理临时元素
                        setTimeout(() => {
                            document.body.removeChild(link);
                            URL.revokeObjectURL(url);
                            if (this.$message) {
                                this.$message.success('图片下载成功！');
                            }
                        }, 100);
                    }
                }, 'image/jpeg');
            } catch (error) {
                console.error('下载失败:', error);
                if (this.$message) {
                    this.$message.error('图片下载失败，请重试');
                }
            }
        },
        // 监听滚动事件
        handleScroll() {
            // 显示/隐藏回到顶部按钮
            this.showBackToTop = window.pageYOffset > 300;
        }
    },

    // 生命周期钩子
    mounted() {
        // 添加滚动监听
        window.addEventListener('scroll', this.handleScroll);
        // 初始化检测当前模型
        this.handleScroll();
    },

    // 组件卸载时移除监听
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    }
};
</script>

<style scoped>
.fanmade-live2d {
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
}

/* 标题卡片样式 */
.section-title-card {
    text-align: center;
    margin-bottom: 30px;
    border-radius: 10px;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    border: none;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.section-main-title {
    font-size: 28px;
    color: #ffad32;
    margin-bottom: 10px;
    letter-spacing: 2px;
    font-weight: bold;
}

.section-description {
    font-size: 16px;
    color: #666;
    line-height: 1.6;
}

/* 回到顶部按钮样式 */
.back-to-top {
    position: fixed;
    right: 40px;
    bottom: 40px;
    width: 40px;
    height: 40px;
    background: rgba(255, 255, 255, 0.95);
    border: 1px solid #e4e7ed;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666;
    font-size: 18px;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    z-index: 999;
}

.back-to-top:hover {
    background: #fff;
    color: #ffad32;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* 模型卡片样式 - 优化整体排版 */
.model-card {
    margin-bottom: 40px;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border: 1px solid #e4e7ed;
}

.model-header {
    padding: 15px 20px;
    background: #fafafa;
    border-bottom: 1px solid #e4e7ed;
}

.model-title {
    font-size: 20px;
    color: #333;
    margin: 0;
    font-weight: bold;
}

/* 模型内容布局 - 优化图片和文字区域比例 */
.model-content {
    padding: 20px;
    display: flex;
    gap: 30px;
    align-items: flex-start;
}

/* 图片区域 - 恢复原本的宽度设置 */
.model-image-section {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 15px;
}

/* 轮播图样式 - 保留原始宽度设置 */
::v-deep .el-carousel__container {
    height: 350px !important;
}

.carousel-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background-color: #ffffff;
}

/* 文字信息区域 - 调整为与图片区域适配的比例 */
.model-info {
    min-width: 280px;
    max-width: 320px;
    background-color: #fafafa;
    padding: 20px 25px;
    border-radius: 8px;
    flex: 1;
}

.info-title {
    font-size: 18px;
    color: #333;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 2px solid #e4e7ed;
}

.info-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.info-item {
    margin-bottom: 12px;
    line-height: 1.6;
    display: flex;
    flex-wrap: wrap;
    /* 允许内容换行 */
}

.info-item:last-child {
    margin-bottom: 0;
}

.info-label {
    font-weight: bold;
    color: #666;
    margin-right: 10px;
    min-width: 60px;
}

.info-value {
    color: #333;
    flex: 1;
}

/* 响应式设计 - 调整移动端显示 */
@media (max-width: 768px) {
    .fanmade-live2d {
        padding: 10px;
    }

    /* 移动端回到顶部按钮调整 */
    .back-to-top {
        right: 20px;
        bottom: 10px;
        width: 40px;
        height: 40px;
        font-size: 18px;
    }
}

/* 优化内容区域布局，使其不受导航栏影响 */
@media (min-width: 769px) {
    .fanmade-live2d {
        margin: 0 auto;
        max-width: 1200px;
    }
}
</style>